/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Restart: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="restart" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 1190A510 510 0 0 0 680 170C538.9 170 411.9666666666667 227.2333333333336 319.6 319.6000000000002L400.0666666666666 400.0666666666669A393.4933333333333 393.4933333333333 0 0 1 680 283.3333333333335C899.3000000000001 283.3333333333335 1076.6666666666665 460.6999999999999 1076.6666666666665 680S899.3000000000001 1076.6666666666667 680 1076.6666666666667S283.3333333333333 899.3000000000001 283.3333333333333 680H453.3333333333333L224.4 451.6333333333333L220.4333333333333 459.5666666666667L0 680H170A510 510 0 0 0 680 1190zM850 680L566.6666666666666 510V850L850 680z" : "M544 952A408 408 0 0 0 544 136C431.12 136 329.5733333333333 181.7866666666668 255.68 255.68L320.0533333333334 320.0533333333334A314.7946666666667 314.7946666666667 0 0 1 544 226.6666666666667C719.44 226.6666666666667 861.3333333333334 368.56 861.3333333333334 544S719.44 861.3333333333333 544 861.3333333333333S226.6666666666667 719.44 226.6666666666667 544H362.6666666666667L179.52 361.3066666666666L176.3466666666667 367.6533333333333L0 544H136A408 408 0 0 0 544 952zM680 544L453.3333333333334 408V680L680 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Restart.displayName = `Blueprint5.Icon.Restart`;
export default Restart;
